import React from 'react';
import { Container } from './style';

const HeaderActionDropdownBase: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default HeaderActionDropdownBase;
